@if (plan) {

  <form [formGroup]="planForm"
        (ngSubmit)="savePlan()"
        autocomplete="off"
        novalidate>

    <div class="row">

      <div class="col-sm-2">

        <div class="form-group"
             [class.error]="yearDropdown.invalid && (yearDropdown.dirty || yearDropdown.touched || mouseoverSavePlanSubmit)">
          <span class="fake-label">Year</span>
          @if (yearDropdown.invalid && (yearDropdown.dirty || yearDropdown.touched || mouseoverSavePlanSubmit)) {
            <em class="error-msg">
              Req
            </em>
          }
          <ng-select formControlName="yearDropdown"
                     bindLabel="description"
                     appendTo="body"
                     [clearable]="false"
                     required>
             @for (year of years; track year.code) {
             <ng-option [value]="year">{{year.description}}</ng-option>
             }
          </ng-select>
        </div>

      </div>

      <div class="col-sm-3">

        <div class="form-group"
             [class.error]="planTypeDropdown.invalid && (planTypeDropdown.dirty || planTypeDropdown.touched || mouseoverSavePlanSubmit)">
          <span class="fake-label">Plan</span>
          @if (planTypeDropdown.invalid && (planTypeDropdown.dirty || planTypeDropdown.touched || mouseoverSavePlanSubmit)) {
            <em class="error-msg">
              Req
            </em>
          }
          <ng-select formControlName="planTypeDropdown"
                     bindLabel="description"
                     appendTo="body"
                     [searchFn]="standardDomainSearchFn"
                     [clearable]="false"
                     required>
             @for (planType of planTypes; track planType.code) {
             <ng-option [value]="planType">{{planType.description}}</ng-option>
             }
          </ng-select>
        </div>

      </div>

      <div class="col-sm-2">

        <div class="form-group"
             [class.error]="shareOffer.invalid && (shareOffer.dirty || shareOffer.touched || mouseoverSavePlanSubmit)">
          <span class="fake-label">Init. Off</span>
          @if (shareOffer.invalid && (shareOffer.dirty || shareOffer.touched || mouseoverSavePlanSubmit)) {
            <em class="error-msg">
              Req
            </em>
          }
          <input formControlName="shareOffer"
                 type="text"
                 mask="separator.0"
                 thousandSeparator=","
                 maxlength="9"
                 name="shareOffer"
                 class="form-control text-right" />
        </div>

      </div>

      <div class="col-sm-2">

        <div class="form-group"
             [class.error]="sharePrice.invalid && (sharePrice.dirty || sharePrice.touched || mouseoverSavePlanSubmit)">
          <span class="fake-label">Share $</span>
          @if (sharePrice.invalid && (sharePrice.dirty || sharePrice.touched || mouseoverSavePlanSubmit)) {
            <em class="error-msg">
              Req
            </em>
          }
          <input formControlName="sharePrice"
                 type="text"
                 name="sharePrice"
                 class="form-control text-right"
                 mask="separator.4"
                 thousandSeparator=","
                 maxlength="8" />
          <!-- currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', precision: 4 }" -->
        </div>

      </div>

      @if (canEdit) {
        <div class="col-sm-3 col-button">

          <span (mouseenter)="mouseoverSavePlanSubmit=true" (mouseleave)="mouseoverSavePlanSubmit=false">
            <app-button [buttonConfig]="{textChange: ['Add', 'Update']}"
                        [textChangeIndex]="+(!!(plan.id))"
                        [isLoading]="isSubmitting"
                        [disabled]="!planForm.valid || isSubmitting"
                        (textBtnClickEmt)="savePlan()"></app-button>
          </span>

        </div>
      }

    </div>

  </form>

}

<app-shareholder-plan-detail-list [shareholder]="shareholder"
                              [canEdit]="canEdit"
                              [plan]="plan"
                              (shareholderUpdated)="shareholderSectionUpdated($event)"></app-shareholder-plan-detail-list>
